// Any so we don't have to cast everything to a bool
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const If = ({ condition, children }: { children: React.ReactNode; condition: any }) => (
  <>{condition ? children : null}</>
);

export default If;
